import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.article`
  position: relative;
  display: flex;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  .language-selector {
    position: absolute;
    top: 25px;
    right: 25px;
    z-index: 10;
  }

  form {
    width: 100%;
    max-width: 384px;
    flex: 0;
    border-radius: 28px;
    box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.25);
    padding: 40px 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: ${ ({ theme }) => theme.colors.white };

    header {
      flex: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 40px;

      img.logoAmb {
        max-width: 260p6x;
      }

      img.logoNemiRounded {
        width: 96px;
        height: 96px;        
      }

      h2 {
        margin: 20px 0 0;
        font-size: 24px;
        font-weight: bold;
        color: ${ ({ theme }) => theme.colors.primary };
      }
    }

    .federated {
      display: flex;
      flex-direction: column;

      /* Our button is the one on screen; Google's sits invisible on top of it, because only
         Google's own button hands back a credential. */
      .google-button {
        position: relative;
        width: 100%;

        .google-pill {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 12px;
          height: 48px;
          width: 100%;
          padding: 0 16px;
          border: solid 1.5px ${ ({ theme }) => theme.colors.grey };
          border-radius: 52px;
          background-color: ${ ({ theme }) => theme.colors.white };
          color: ${ ({ theme }) => theme.colors.black };
          font-family: ${ ({ theme }) => theme.fontFamily };
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;

          &:hover {
            background-color: ${ ({ theme }) => theme.colors.almostWhite };
          }

          img {
            width: 28px;
            height: 28px;
            flex-shrink: 0;
          }
        }

        .google-gsi {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          overflow: hidden;

          /* Google's button is 44px tall and cannot be resized: stretch the (invisible) hit
             area so the whole pill is clickable. */
          > div {
            transform: scaleY(1.2);
          }
        }
      }
    }

    .divider {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
      margin: 24px 0;
      color: ${ ({ theme }) => theme.colors.black };
      font-size: 12px;
      white-space: nowrap;

      &::before,
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background-color: ${ ({ theme }) => theme.colors.greyLight };
      }
    }

    .fields {
      display: flex;
      flex-direction: column;
    }

    .link {
      text-align: center;

      span {
        color: ${ ({ theme }) => theme.colors.primary };
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 15px;
        text-align: center;
        cursor: pointer;
      }

      :hover {
        text-decoration: underline;
      }
    }

    .forgotten-password {
      text-align: right;
      margin-top: -25px;

      span {
        font-size: 14px;
        font-weight: 400;
      }
    }

    .actions {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;

      button {
        height: 52px;
        font-size: 16px;
        letter-spacing: 1px;

        /* The mock greys the button out in the brand's purple, not in grey. */
        &.filled:disabled {
          background-color: ${ ({ theme }) => withOpacity(theme.colors.primary, 35) };
        }
      }

      .divider {
        margin: 28px 0 20px;
      }

      .secondary-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;

        span {
          /* Both links share the row evenly, whatever the length of their labels. */
          flex: 1 1 0;
          min-width: 0;
          color: ${ ({ theme }) => theme.colors.primary };
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 0.5px;
          text-align: center;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .error-container {
      flex-direction: row;
      justify-content: center;
      margin-top: 25px;
      width: 100%;
      text-align: center;
      align-self: center;

      .error {
        color: ${ ({ theme }) => theme.colors.red };
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 16px;

    .language-selector {
      top: 16px;
      right: 16px;
    }

    form {
      padding: 32px 24px 24px;
    }
  }
`
